<template>
  <Dialogo
    title="Tabela de Preços"
    ref="dialogo"
    :subtitle="produto ? produto.nome : ''"
    :loading="loading"
  >
    <v-simple-table>
      <thead>
        <tr>
          <th>
            Dias
          </th>
          <th>
            Preço
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="precos.length === 0">
          <td colspan="4" class="text-center">Nenhum preço encontrado</td>
        </tr>
        <tr
          v-for="preco in precos"
          :key="preco.id"
          @click="alterarPreco(preco)"
          style="cursor: pointer;"
        >
          <td>
            {{ preco.dias }}
          </td>
          <td>
            {{ preco.preco_formatado }}
          </td>
          <td class="text-right">
            <v-btn @click.stop="removerPreco(preco)" icon color="red">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </td>
        </tr>
        <tr>
          <td colspan="4">
            <v-btn @click="adicionarPreco()" text color="primary">
              <v-icon left>mdi-plus</v-icon> Adicionar
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <FormularioPrecoDialogo @salvo="carregarPrecos()" ref="dialogo_preco" />
  </Dialogo>
</template>

<script>
import Dialogo from "@/components/dialogos/Dialogo.vue";
import api from "@/services/locacoes.js";
import FormularioPrecoDialogo from "./FormularioPrecoDialogo.vue";
import alertsMixin from "../../../mixins/alerts";

export default {
  mixins: [alertsMixin],

  components: {
    Dialogo,
    FormularioPrecoDialogo
  },

  props: {},

  data() {
    return {
      produto: null,
      precos: [],
      loading: false
    };
  },

  methods: {
    async abrir(produto) {
      this.produto = { ...produto };
      this.$refs.dialogo.open();
      await this.carregarPrecos();

      if (this.precos.length < 1) {
        this.adicionarPreco();
      }
    },

    fechar() {
      this.$refs.dialogo.close();
    },

    adicionarPreco() {
      this.$refs.dialogo_preco.abrir(this.produto.id);
    },

    alterarPreco(preco) {
      this.$refs.dialogo_preco.abrir(this.produto.id, { ...preco });
    },

    async carregarPrecos() {
      this.loading = true;
      try {
        this.precos = await api.precos_produto.listarPorProduto(
          this.produto.id
        );
        this.$emit("updated");
      } catch (error) {
        this.handleRequestError(
          error,
          "Não foi possível carregar tabela de preços"
        );
      } finally {
        this.loading = false;
      }
    },

    async removerPreco(preco) {
      try {
        this.precos = await api.precos_produto.remover(
          this.produto.id,
          preco.dias
        );
        this.alert("Removido");
        this.carregarPrecos();
        this.$emit("updated");
      } catch (error) {
        this.handleRequestError(error, "Não foi possível remover o preço");
      }
    }
  },

  computed: {}
};
</script>
